import { gatewayClient } from 'utils/gatewayClient';
import queryString from 'query-string';
import { PretaxV2ClaimStatus } from 'constants/claims';

export type FetchPretaxClaimsResponse = Array<{
  id: string;
  createdAt: string;
  employeeAccountId: string;
  merchant: string;
  status: PretaxV2ClaimStatus;
  transactionAmount: number;
  transactionDate: string;
  employeeAccount: {
    id: string;
    companyPlan: {
      description: string;
      name: string;
      planType: string;
    };
  };
}>;

export function fetchPretaxClaims(query: {
  size: number;
  page: number;
  status?: string | null;
}) {
  return gatewayClient.get<FetchPretaxClaimsResponse>(
    `/pretax/claims?${queryString.stringify(query)}`,
    { headers: { 'pretax-api-version': 2 } }
  );
}

export interface FetchPretaxClaimByIdResponse {
  claim: {
    id: string;
    category: string;
    claimantName: string;
    createdAt: string;
    employeeId: string;
    employeeAccount: {
      id: string;
      companyPlan: {
        description: string;
        name: string;
        planType: string;
      };
    };
    merchant: string;
    note: string;
    receipts: Array<{
      filename: string;
      id: string;
      receiptDate: string;
      storageMethod: string;
    }>;
    reimbursementInfo: {
      approvedAmount: number;
      employeeNote: string;
      ineligibleAmount: number;
    };
    recurringClaims: [
      {
        id: string;
        reimbursementInfo: {
          approvedAmount: number;
        };
        status: PretaxV2ClaimStatus;
        updatedAt: string;
      }
    ];
    status: PretaxV2ClaimStatus;
    transactionAmount: number;
    transactionDate: string;
    updatedAt: string;
    reviewer: string;
  };
}
export function fetchPretaxClaimById({ id }: { id: string }) {
  return gatewayClient.get<FetchPretaxClaimByIdResponse>(
    `/pretax/claims/${id}`,
    { headers: { 'pretax-api-version': 2 } }
  );
}

export interface FetchPretaxClaimReceiptByIdResponse {
  receipt: {
    Base64: string;
    FileName: string;
  };
}
export function fetchPretaxClaimReceiptById(file_key: string) {
  return gatewayClient.get<FetchPretaxClaimReceiptByIdResponse>(
    `/cdh/v2/claims/receipts/${file_key}`
  );
}

export function createPretaxClaim({
  amount,
  category,
  claimant,
  default_employee_wallet_id,
  note,
  receipt,
  reimbursement_vendor,
  transaction_date,
  account_id,
}: {
  amount: number;
  category: string;
  claimant: string;
  default_employee_wallet_id: string;
  note: string;
  receipt: Array<{
    base64: string;
    content_type: string | null;
    file_name: string;
  }>;
  reimbursement_vendor: string;
  transaction_date: string;
  account_id: string;
}) {
  return gatewayClient.post('/cdh/v2/claims', {
    amount,
    category,
    claimant,
    default_employee_wallet_id,
    note,
    receipt,
    reimbursement_vendor,
    transaction_date,
    account_id,
  });
}
